var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "533 483 19.983 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gst",
    transform: "translate(731 547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gst-2",
    "data-name": "gst"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M19.865,2a1.151,1.151,0,0,0-1.635-.545L13.718,4.391a.307.307,0,0,0,.333.515l4.482-2.937a.539.539,0,0,1,.757.3.755.755,0,0,1-.273.939L14.535,6.147,11.6,7.964a1.576,1.576,0,0,1-1.423.151L6.3,6.723c-.03,0-.061-.03-.121-.03l-1.3.061V1.484c.666-.151,2.756-.545,3.664.606a.984.984,0,0,0,.757.333h3.331a.639.639,0,0,1,.575.666.639.639,0,0,1-.575.666H9.478a.85.85,0,0,0-.787.515A.972.972,0,0,0,8.751,5.3a.284.284,0,0,0,.424.091.326.326,0,0,0,.061-.424.462.462,0,0,1-.03-.394c.03-.03.091-.182.242-.182h3.18a1.244,1.244,0,0,0,1.181-1.272,1.224,1.224,0,0,0-1.181-1.272H9.3a.31.31,0,0,1-.273-.121C7.964.363,5.784.666,4.875.878V.3a.286.286,0,0,0-.3-.3H.3A.286.286,0,0,0,0,.3v7.54a.286.286,0,0,0,.3.3H4.6a.286.286,0,0,0,.3-.3V7.419l1.272-.061L9.993,8.721a2.185,2.185,0,0,0,1.938-.212l2.937-1.847L19.35,3.725A1.371,1.371,0,0,0,19.865,2ZM4.3,7.51H.606V.575H4.3Z",
    transform: "translate(-198 -52.856)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-2",
    "data-name": "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M4.144,9.085H7.082c2.483,0,3.482-1.12,3.876-2.059.727-1.756-.121-4.149-1.363-5.42L8.111.091A.275.275,0,0,0,7.9,0H3.327a.275.275,0,0,0-.212.091L1.631,1.6C.39,2.877-.458,5.269.268,7.025.662,7.964,1.661,9.085,4.144,9.085ZM2.055,2.029,3.448.606h4.33L9.171,2.029c1.12,1.151,1.878,3.24,1.241,4.754-.454,1.12-1.6,1.7-3.331,1.7H4.144c-1.7,0-2.846-.575-3.331-1.7C.178,5.269.935,3.18,2.055,2.029Z",
    transform: "translate(-190.365 -60.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-3",
    "data-name": "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M1.136,2.544a.291.291,0,0,0,.273.182H4.467a.318.318,0,0,0,.273-.151L5.829.454a.354.354,0,0,0,0-.3A.27.27,0,0,0,5.587,0H.318A.361.361,0,0,0,.045.151a.275.275,0,0,0,0,.3ZM5.072.606,4.285,2.12H1.59L.8.606Z",
    transform: "translate(-187.689 -64)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-4",
    "data-name": "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M2.574,5.178A2.572,2.572,0,0,0,5.148,2.6,2.6,2.6,0,0,0,2.574,0,2.572,2.572,0,0,0,0,2.574,2.6,2.6,0,0,0,2.574,5.178Zm0-4.573A1.968,1.968,0,1,1,.606,2.574,1.964,1.964,0,0,1,2.574.606Z",
    transform: "translate(-187.311 -58.549)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-5",
    "data-name": "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M.3,2.271,0,2.635a1.882,1.882,0,0,0,1,.454v.3h.273v-.3a.943.943,0,0,0,.666-.242.679.679,0,0,0,.242-.575.648.648,0,0,0-.212-.545,2.164,2.164,0,0,0-.7-.3V.666a1.378,1.378,0,0,1,.575.242L2.12.545a1.8,1.8,0,0,0-.848-.3V0H1V.212A.867.867,0,0,0,.363.454a.775.775,0,0,0-.242.575.648.648,0,0,0,.212.545,1.963,1.963,0,0,0,.666.3v.787A1.831,1.831,0,0,1,.3,2.271Zm1-.363a1.16,1.16,0,0,1,.333.151.3.3,0,0,1-.03.454.907.907,0,0,1-.3.121ZM.727,1.181A.275.275,0,0,1,.636.969.344.344,0,0,1,.727.727a.569.569,0,0,1,.3-.121v.7A.356.356,0,0,1,.727,1.181Z",
    transform: "translate(-185.857 -57.641)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGst);
export default __webpack_public_path__ + "static/media/gst.fff652742415c85f06c391dddbe46371.svg";
export { ForwardRef as ReactComponent };